import React from 'react';
import classNames from 'classnames';

import EventPopUp from './EventPopUp';
import { Event } from './types';
import Text from '../text/Text';

function EventItem({
  event,
  activeId,
  setActiveId,
  idx,
  eventCard,
}: {
  event: Event;
  activeId: string | number;
  setActiveId: (data: string | number) => void;
  idx: number;
  eventCard?: (data: Event) => React.JSX.Element;
}) {
  function truncate(input) {
    if (input.length > 30) {
      return input.substring(0, 30) + '...';
    }
    return input;
  }

  return (
    <div key={event.id}>
      <div
        className={classNames('p-2 m-1 pointer rounded-4 ', {
          'bg-success-lighter': idx % 2 === 0,
          'bg-warning-lighter': idx % 2 === 1,
        })}
        onClick={() => {
          setActiveId(event.id);
        }}
      >
        <Text size="xs">{truncate(event.label)}</Text>
      </div>
      {activeId === event.id ? (
        <EventPopUp
          event={event}
          setActiveId={setActiveId}
          eventCard={eventCard}
        />
      ) : null}
    </div>
  );
}

export default EventItem;
